
/* replaceUrlParam - http://stackoverflow.com/questions/7171099/how-to-replace-url-parameter-with-javascript-jquery */
function replaceUrlParam(e,r,a){var n=new RegExp("("+r+"=).*?(&|$)"),c=e;return c=e.search(n)>=0?e.replace(n,"$1"+a+"$2"):c+(c.indexOf("?")>0?"&":"?")+r+"="+a};

var $ = jQuery;

// https://github.com/scdoshi/jquery-ajaxchimp
(function($){"use strict";$.ajaxChimp={responses:{"We have sent you a confirmation email":0,"Please enter a value":1,"An email address must contain a single @":2,"The domain portion of the email address is invalid (the portion after the @: )":3,"The username portion of the email address is invalid (the portion before the @: )":4,"This email address looks fake or invalid. Please enter a real email address":5},translations:{en:null},init:function(selector,options){$(selector).ajaxChimp(options)}};$.fn.ajaxChimp=function(options){$(this).each(function(i,elem){var form=$(elem);var email=form.find("input[type=email]");var label=form.find("label[for="+email.attr("id")+"]");var settings=$.extend({url:form.attr("action"),language:"en"},options);var url=settings.url.replace("/post?","/post-json?").concat("&c=?");form.attr("novalidate","true");email.attr("name","EMAIL");form.submit(function(){var msg;function successCallback(resp){if(resp.result==="success"){msg="We have sent you a confirmation email";label.removeClass("error").addClass("valid");email.removeClass("error").addClass("valid")}else{email.removeClass("valid").addClass("error");label.removeClass("valid").addClass("error");var index=-1;try{var parts=resp.msg.split(" - ",2);if(parts[1]===undefined){msg=resp.msg}else{var i=parseInt(parts[0],10);if(i.toString()===parts[0]){index=parts[0];msg=parts[1]}else{index=-1;msg=resp.msg}}}catch(e){index=-1;msg=resp.msg}}if(settings.language!=="en"&&$.ajaxChimp.responses[msg]!==undefined&&$.ajaxChimp.translations&&$.ajaxChimp.translations[settings.language]&&$.ajaxChimp.translations[settings.language][$.ajaxChimp.responses[msg]]){msg=$.ajaxChimp.translations[settings.language][$.ajaxChimp.responses[msg]]}label.html(msg);label.show(2e3);if(settings.callback){settings.callback(resp)}}var data={};var dataArray=form.serializeArray();$.each(dataArray,function(index,item){data[item.name]=item.value});$.ajax({url:url,data:data,success:successCallback,dataType:"jsonp",error:function(resp,text){console.log("mailchimp ajax submit error: "+text)}});var submitMsg="Submitting...";if(settings.language!=="en"&&$.ajaxChimp.translations&&$.ajaxChimp.translations[settings.language]&&$.ajaxChimp.translations[settings.language]["submit"]){submitMsg=$.ajaxChimp.translations[settings.language]["submit"]}label.html(submitMsg).show(2e3);return false})});return this}})(jQuery);

// Money formatting
if ((typeof Shopify) === 'undefined') { Shopify = {}; }
if (!Shopify.formatMoney) {
  Shopify.formatMoney = function(cents, format) {
    // console.log("Shopify.formatMoney Format: ", format);
    var value = '',
        placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString = (format || "${{amount}}");
    // console.log("Format String: ", formatString);
    // console.log(formatString.match(placeholderRegex))
    if (typeof cents == 'string') {
      cents = cents.replace('.','');
    }

    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number/100.0).toFixed(precision);

      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
    }

    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };
}

// Functions
window.concrete = window.concrete || {};
concrete.cacheSelectors = function () {
  concrete.cache = {
    // General
    $html : $('html'),
    $body : $(document.body),
    // Visibility
    $toggleItemLink : $('.js_toggle'),
    $revealItemLink : $('.js_open'),
    $hideItemLink : $('.js_close'),
    // Collection Pages
    $changeView : $('.change-view'),
    // Products
    $productMainImage : $('#ProductMainImage'),
    $productThumbnailImages : $('#ProductThumbnailImages').find('a.thumbnail'),
    // Login Forms
    $recoverPasswordLink : $('#RecoverPasswordLink'),
    $hideRecoverPasswordLink : $('#HideRecoverPasswordLink'),
    $recoverPasswordForm : $('#RecoverPasswordForm'),
    $customerLoginForm : $('#LoginForm'),
    $passwordResetSuccess : $('#ResetSuccess'),
    $cartCounter: $('#CartCounter')
    // Cart JS

    // TO DO
    // Move variables from "Variant Switching" function

  };
};


// Initialize the functions
concrete.init = function () {
  concrete.cacheSelectors();
  concrete.visibilityManager();
  concrete.responsiveVideos();
  concrete.collectionViews();
  concrete.productImageSwitch();
  concrete.popups();
  concrete.loginForms();
  concrete.cartCounter();
};

// Get current window location
concrete.getHash = function () {
  return window.location.hash;
};

// responsive Videos
concrete.cartCounter = function () {
  $(document).on('cart.requestComplete', function(event, cart) {
      var count = cart.item_count;
      if (count == 0){
        concrete.cache.$cartCounter.html('');
      } else {
        concrete.cache.$cartCounter.html(cart.item_count);
      }
  });
};


// responsive Videos
concrete.responsiveVideos = function () {
  var $iframeVideo = $('iframe[src*="youtube.com/embed"], iframe[src*="player.vimeo"]');
  var $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');
  $iframeVideo.each(function () {
    // Add wrapper to make video responsive
    $(this).wrap('<div class="video-wrapper"></div>');
  });
  $iframeReset.each(function () {
    // Re-set the src attribute on each iframe after page load
    // for Chrome's "incorrect iFrame content on back" bug https://code.google.com/p/chromium/issues/detail?id=395791
    // Need to specifically target video and admin bar
    this.src = this.src;
  });
};

// Collection view switching
concrete.collectionViews = function () {
  if (concrete.cache.$changeView.length) {
    concrete.cache.$changeView.on('click', function() {
      var view = $(this).data('view'),
          url = document.URL,
          hasParams = url.indexOf('?') > -1;
      if (hasParams) {
        window.location = replaceUrlParam(url, 'view', view);
      } else {
        window.location = url + '?view=' + view;
      }
    });
  }
};

// Visibility Management

concrete.visibilityManager = function() {
  // Reveal elements on toggle
  concrete.cache.$toggleItemLink.on('click', function(event) {
    event.preventDefault();
    var itemId = $(this).attr('href');
    $(itemId).toggleClass('hidden');
  });
  // display elements on click
  concrete.cache.$revealItemLink.on('click', function(event) {
    event.preventDefault();
    var itemId = $(this).attr('href');
    $(itemId).removeClass('hidden');
  });
  // hide elements on click
  concrete.cache.$hideItemLink.on('click', function(event) {
    event.preventDefault();
    var itemId = $(this).attr('href');
    $(itemId).addClass('hidden');
  });
};

// Popups
concrete.popups = function() {
  // Move popups to the end of the body
  $('.popup').detach().appendTo('body');
  // Close popup
  $('.popup').on('click', '.popup-close, .popup-cancel, .popup-outside', function(event){
    event.preventDefault();
    $(this).closest('.popup').removeClass('visible');
  });
  // Close popup when clicking the esc keyboard button
  $(document).keyup(function(event){
    if(event.which=='27'){
      $('.popup').removeClass('visible');
    }
  });
};
// Open things based on their ID as data-attribute
$('.popup-link').on('click', function(event) {
  event.preventDefault();
  var popupId = $(this).attr('data-popup');
  $(popupId + '.popup').addClass('visible');
});

// Product Image Thumbnails
concrete.productImageSwitch = function () {
  if (concrete.cache.$productThumbnailImages.length) {
    // Switch the main image with one of the thumbnails
    // Note: this does not change the variant selected, just the image
    concrete.cache.$productThumbnailImages.on('click', function(event) {
      event.preventDefault();
      var newImage = $(this).attr('href');
      concrete.switchImage(newImage, null, concrete.cache.$productMainImage);
    });
  }
};

concrete.switchImage = function (src, imgObject, el) {
  // Make sure element is a jquery object
  var $el = $(el);
  $el.attr('src', src);
};

// Variant Switching
concrete.switchVariant = function(options) {
  var moneyFormat = options.moneyFormat,
      variant = options.variant;
  var $addToCart = $("#AddToCart");
  var $addToCartText = $("#AddToCartText");
  var $productPrice = $("#ProductPrice");
  var $comparePrice = $("#ComparePrice");
  var $onSale = $("#OnSale");
  if (variant) {
    if (variant.featured_image) {
      // console.log("Switching image");
      Shopify.Image.switchImage(variant.featured_image, $("#ProductMainImage")[0], function(i, e, t) {
        // console.log(i, e, t);
        var $t = $(t);
        $t.attr('src', i);
      });
    } else {
      // console.log("No image");
    }
    // Disabled button if variant is unavailable
    if (variant.available) {
      $addToCart.removeClass("disabled").prop('disabled', false);
      $addToCartText.html("Add to Cart");
      $addToCart.attr("data-cart-add", variant.id);
      $("#Quantity").attr('max', variant.inventory_quantity);
    } else {
      $addToCart.addClass("disabled").prop('disabled', true);
      $addToCartText.html("Unavailable");
    }

    $productPrice.html(Shopify.formatMoney(variant.price, moneyFormat));
    // Hide the compare at price if the item is not on sale
    if (variant.compare_at_price > variant.price) {
      $comparePrice.html(Shopify.formatMoney(variant.compare_at_price, moneyFormat));
      $onSale.show();
    } else {
      $onSale.hide();
    }
  }
};

// Login Forms

concrete.loginForms = function() {
  function showRecoverPasswordForm() {
    event.preventDefault();
    concrete.cache.$recoverPasswordForm.show();
    concrete.cache.$customerLoginForm.hide();
  }
  function hideRecoverPasswordForm() {
    event.preventDefault();
    concrete.cache.$recoverPasswordForm.hide();
    concrete.cache.$customerLoginForm.show();
  }
  concrete.cache.$recoverPasswordLink.on('click', function(event) {
    event.preventDefault();
    showRecoverPasswordForm();
  });
  concrete.cache.$hideRecoverPasswordLink.on('click', function(event) {
    event.preventDefault();
    hideRecoverPasswordForm();
  });
  // Allow deep linking to recover password form
  if (concrete.getHash() == '#recover') {
    showRecoverPasswordForm();
  }
};
concrete.resetPasswordSuccess = function() {
  concrete.cache.$passwordResetSuccess.show();
};

// Initialize on docready
$(concrete.init);


